// HashLink
// Scroll on click/Documentready

// Scroll margin from top
if (typeof scrollMargin === 'undefined') {
    scrollMargin = 25;
}

let headerHeight = 0;
let fixedHeader = false;
if($('[data-fixed-header]').length>0) {
    headerHeight = Math.round($('[data-fixed-header]').height());
    fixedHeader = true;
}

$(window).on('load scroll', function () {
    // recheck header height
    headerHeight = Math.round($('[data-fixed-header]').height());
});


// On click
$('body').on('click', 'a[data-scroll-link], a[href^="#"]', function(e) {
    e.preventDefault();

    // find hashTarget
    var hashTarget = 0;
    var attr = $(this).attr('data-scroll-link');
    if (typeof attr !== typeof undefined && attr !== false) {
        var hashTarget = $(this).attr('data-scroll-link');
    } else {
        var defaultLink = $(this).attr('href');
        var hashTarget = defaultLink.substr(1)
    }

    // if mobile menu is open, close it after click
    if($('body').hasClass('open-menu')) {
        $('body.open-menu').removeClass('open-menu');
    }

    // if link is on the page scroll
    if($('#'+hashTarget).length>0) {

        // calculate scroll position
        let scrollPosition = $('#'+hashTarget).offset().top - scrollMargin;
        if (fixedHeader !== false) {
            scrollPosition = scrollPosition - headerHeight;
        }

        // scroll to scrollPosition
        $('html,body').animate({scrollTop:scrollPosition}, 500);

        // update browser url
        window.location.hash = hashTarget;

        // if link isn't on the page redirect to BASE_HREF
    } else {

        location.href = BASE_HREF+'#'+hashTarget;
        return false;

    }
});


// On page load
$(window).on('load', function() {

    // HashLink Scroll on Documentready
    if(window.location.hash) {

        // find hash
        let hashTarget = window.location.hash.substring(1);

        // Check if id exists on page
        if($('#'+hashTarget+'').length>0) {

            // calculate scroll position
            let scrollPosition = $('#'+hashTarget).offset().top - scrollMargin;
            if (fixedHeader !== false) {
                scrollPosition = scrollPosition - headerHeight;
            }

            // scroll to scrollPosition
            $('html,body').animate({scrollTop:scrollPosition}, 0);

        }
    }
});
